import axiosInstance from "../../_helpers/axios_instance";

interface FetchParams {
  endpoint: string;
  filters?: Record<string, unknown>;
}

interface MutateParams extends FetchParams {
  payload?: unknown;
}

const normalize = (data: unknown): unknown => {
  if (data && typeof data === 'object' && 'data' in data) return (data as Record<string, unknown>).data;
  return data;
};

export const fetchData = async ({ endpoint, filters }: FetchParams): Promise<unknown> => {
  const params = { ...filters };
  try {
    const response = await axiosInstance.get(`/api/${endpoint}`, { params });
    return normalize(response?.data);
  } catch (error) {
    console.error(`Failed to fetch data for endpoint: ${endpoint}`, error);
    throw error;
  }
};

export const updateData = async ({ endpoint, filters, payload }: MutateParams): Promise<unknown> => {
  const params = { ...filters };
  try {
    const response = await axiosInstance.put(`/api/${endpoint}`, payload, { params });
    return normalize(response?.data);
  } catch (error) {
    console.error(`Failed to update data for endpoint: ${endpoint}`, error);
    throw error;
  }
};

export const postData = async ({ endpoint, filters, payload }: MutateParams): Promise<unknown> => {
  const params = { ...filters };
  try {
    const response = await axiosInstance.post(`/api/${endpoint}`, payload, { params });
    return normalize(response?.data);
  } catch (error) {
    console.error(`Failed to post data for endpoint: ${endpoint}`, error);
    throw error;
  }
};

export const patchData = async ({ endpoint, filters, payload }: MutateParams): Promise<unknown> => {
  const params = { ...filters };
  try {
    const response = await axiosInstance.patch(`/api/${endpoint}`, payload, { params });
    return normalize(response?.data);
  } catch (error) {
    console.error(`Failed to patch data for endpoint: ${endpoint}`, error);
    throw error;
  }
};

export const deleteData = async ({ endpoint, filters }: FetchParams): Promise<unknown> => {
  const params = { ...filters };
  try {
    const response = await axiosInstance.delete(`/api/${endpoint}`, { params });
    return normalize(response?.data);
  } catch (error) {
    console.error(`Failed to delete data for endpoint: ${endpoint}`, error);
    throw error;
  }
};
